module.exports = __webpack_public_path__ + "51d37868be9da757faa9e7a7f130ea4e.png";